import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import IndicatorData from './indicator-data';
import IndicatorDataDetail from './indicator-data-detail';
import IndicatorDataUpdate from './indicator-data-update';
import IndicatorDataDeleteDialog from './indicator-data-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={IndicatorDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={IndicatorDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={IndicatorDataDetail} />
      <ErrorBoundaryRoute path={match.url} component={IndicatorData} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={IndicatorDataDeleteDialog} />
  </>
);

export default Routes;
